import React, { SVGProps } from 'react'

export const FifthActiveCenterSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="36"
    fill="none"
    preserveAspectRatio="none"
    viewBox="0 0 74 36"
    {...props}
  >
    <path
      fill="currentColor"
      d="M54.642.418C41.724.996 30.402 0 16.033 0 12.8 0 4.367.213 0 1v34c13.5.5 27.703.886 41.01.886 10.384 0 22.507.588 32.99-.908V.998C67.1.022 59.796-.111 54.642.418Z"
    />
  </svg>
)
